import { render, staticRenderFns } from "./productConsumption.vue?vue&type=template&id=e9dc3a48&"
import script from "./productConsumption.vue?vue&type=script&lang=js&"
export * from "./productConsumption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports